import { useCallback, useEffect, useState } from 'react'

import { TokenResult } from '../../firebase/messaging'
import { InProgressGameApi } from '../GameApi/InProgressGameApi'

interface NotificationsApi {
  notifications: TokenResult
  showNotificationStatus: () => void
}

export function useNotifications(gameApi: InProgressGameApi): NotificationsApi {
  const [notifications, setNotifications] = useState<TokenResult>({
    success: false,
    error: 'init',
  })

  useEffect(() => {
    gameApi
      .setupNotifications()
      .then((res) => {
        setNotifications(res)
      })
      .catch((err) => {
        console.error('notifications setup error', err)
        setNotifications({
          success: false,
          error: err.message,
        })
      })

    // clear notifications on visibility change
    async function handleVisibilityChange() {
      if (document.visibilityState !== 'visible') {
        return
      }

      const registrations = await navigator.serviceWorker.getRegistrations()
      const registration = registrations[0]
      if (!registration) {
        return
      }

      const allNotifications = await registration.getNotifications()

      allNotifications.forEach(function (notification) {
        if (notification.tag === gameApi.gameId || notification.tag === '') {
          notification.close()
        }
      })
    }
    handleVisibilityChange()
    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  // NOTE: gameApi is intentionally omitted from deps — adding it would re-run
  // setupNotifications() on every model update (gameApi is recreated when the
  // Firestore snapshot changes), causing repeated FCM token registration.

  const showNotificationStatus = useCallback(() => {
    alert(
      [
        `Notifications are ${notifications?.success ? 'enabled' : 'disabled'}`,
        `\ndetails:`,
        `isIndexedDBAvailable: ${typeof indexedDB === 'object'}`,
        `areCookiesEnabled: ${navigator.cookieEnabled}`,
        `serviceWorker: ${'serviceWorker' in navigator}`,
        `PushManager: ${'PushManager' in window}`,
        `Notification: ${'Notification' in window}`,
        // eslint-disable-next-line no-prototype-builtins
        `ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') : ${ServiceWorkerRegistration?.prototype.hasOwnProperty(
          'showNotification',
        )}`,
        // eslint-disable-next-line no-prototype-builtins
        `PushSubscription.prototype.hasOwnProperty('getKey'): ${PushSubscription?.prototype.hasOwnProperty(
          'getKey',
        )}`,
        `notifications.error: ${notifications?.error}`,
      ].join('\n'),
    )
  }, [notifications])

  return { notifications, showNotificationStatus }
}
